import {z} from "zod"
import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {AddressMode, box2Like, size2Like, vector2Like} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"
import {imageOpHalOptions} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/hal/image-op-hal-types"

// either a box or an offsetImage (1x1 >=2-channel image for x/y offset) and offset is added to offsetImage along with the size
export const extRegion = box2Like.or(
    z
        .object({
            offsetImage: anyImageOpResult,
            offset: vector2Like.optional(),
        })
        .and(size2Like),
)

export type ExtRegion = z.infer<typeof extRegion>

export const Definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            imageOpHalOptions: imageOpHalOptions,

            sourceImage: anyImageOpResult,
            region: extRegion, // region to extract (on mip level implied by mip level offset)
            mipLevelOffset: z.number().optional().default(0), // which mip level to extract relative to the source image (can be negative)
            addressMode: AddressMode.optional().default("border"),
        }),
    },
}
